import React from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShieldHalved,
  faStar,
  faCircleCheck,
  faFileShield,
  faHeadset,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Why_Section.css";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

const whyUsData = [
  {
    id: 1,
    title: "MEA Approved & Government Registered",
    description:
      "We are fully registered with the Ministry of External Affairs (MEA) and Government of India. Our License No: B-3395/UP/COM/100/5/11401/2026 ensures complete legal compliance and credibility.",
    icon: faShieldHalved,
  },
  {
    id: 2,
    title: "15+ Years of Excellence",
    description:
      "With over 15 years of industry experience, we have built strong relationships with employers worldwide and understand the nuances of international recruitment.",
    icon: faStar,
  },
  {
    id: 3,
    title: "1000+ Successful Placements",
    description:
      "Our proven track record of over 1000 successful placements across 50+ countries demonstrates our capability and commitment to excellence.",
    icon: faCircleCheck,
  },
  {
    id: 4,
    title: "100% Legal & Transparent",
    description:
      "We maintain complete transparency in all dealings. No hidden charges, no illegal practices - just straightforward, compliant recruitment services.",
    icon: faFileShield,
  },
  {
    id: 5,
    title: "24/7 Support Available",
    description:
      "Our dedicated support team is available round-the-clock to assist you with any queries, visa issues, or concerns at any time.",
    icon: faHeadset,
  },
  {
    id: 6,
    title: "Professional Guidance",
    description:
      "Our experienced consultants provide personalized guidance through every step of your recruitment journey from application to placement.",
    icon: faUserCheck,
  },
];

const Why_Section = () => {
  return (
    <section className="why_section">
      <Container>
        <div className="why_section_heading">
          <CommonHeading title="Why Choose Us" />
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={24}
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            500: {
              slidesPerView: 2,
            },
            576: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
          }}
          className="why_swiper"
        >
          {whyUsData.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="why_card">
                <div className="why_icon_box">
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <div className="why_content">
                  <h3 className="why_title">{item.title}</h3>

                  <p className="why_text">{item.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default Why_Section;
